import { ModalOptions } from '@siemens/element-ng/modal';

export const STANDARD_MODAL_CONFIG = {
  ignoreBackdropClick: false,
  keyboard: true,
  animated: true,
  class: 'modal-dialog-centered'
} as ModalOptions;
